import React, { useEffect, useRef, useState } from 'react';

import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { useGetInviteData } from '@pkg/hooks';

import { useOnClickOutside } from '@app/helpers/hooks';

import { ButtonWrapper, GrowYourPodsWrapper, PromptArrow, PromptHeading, PromptSubheading, TextButton } from './styles';

interface Props {
    handleOpenPanel(): void;
    isMobile?: boolean;
}

export const LOCAL_STORAGE_GROW_PODS_SEEN = 'growPodsSeen';

export const GrowYourPodsPrompt = ({ handleOpenPanel, isMobile = false }: Props) => {
    const theme = useTheme();
    const divRef = useRef<HTMLDivElement>(null);
    const { t } = useTranslation('groups');

    const seenPrompt = localStorage.getItem(LOCAL_STORAGE_GROW_PODS_SEEN);
    const { data } = useGetInviteData();
    const showInitialPrompt = data && data.invites_consumed < data.invite_limit && !seenPrompt;

    const [showPrompt, setShowPrompt] = useState(!!showInitialPrompt);

    const handleHidePrompt = () => {
        setShowPrompt(false);
        localStorage.setItem(LOCAL_STORAGE_GROW_PODS_SEEN, '1');
    };

    const handleClick = () => {
        handleOpenPanel();
        handleHidePrompt();
    };

    useOnClickOutside(divRef, () => {
        handleHidePrompt();
    });

    useEffect(() => {
        if (showInitialPrompt) {
            setShowPrompt(showInitialPrompt);
        }
    }, [showInitialPrompt]);

    return (
        <div ref={divRef}>
            <AnimatePresence>
                {showPrompt && (
                    <GrowYourPodsWrapper
                        isMobile={isMobile}
                        exit={{ opacity: 0, translateY: '10px' }}
                        transition={{
                            duration: theme.transitions.speeds.fast,
                        }}
                    >
                        <PromptArrow />
                        <PromptHeading>{t('grow_pods_heading')}</PromptHeading>
                        <PromptSubheading>{t('grow_pods_subheading')}</PromptSubheading>
                        <ButtonWrapper>
                            <TextButton onClick={handleClick}>{t('grow_pods_button_text')}</TextButton>
                        </ButtonWrapper>
                    </GrowYourPodsWrapper>
                )}
            </AnimatePresence>
        </div>
    );
};
